import { Navigate } from "react-router";
import { Spinner } from "../../components/Spinner/Spinner.tsx";
import { USER_ONBOARDING } from "../../routes.ts";
import { useUser } from "../hooks/useUser.ts";

export const UserOnboardingRedirect = () => {
  const { user } = useUser();
  if (!user) return <Spinner />;
  return <Navigate replace to={USER_ONBOARDING} />;
};
